import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import React from 'react';
/**
 * Bugsnag integration supporting React including CSR and SSR use cases.
 *
 * See:
 *  https://docs.bugsnag.com/platforms/javascript/react/
 *  https://github.com/bugsnag/bugsnag-js/tree/master/examples/nextjs
 */

/**
 * These are the API keys for modsy.com
 */

var BUGSNAG_CLIENT_API_KEY = 'fa5686ad7b635de62a4f5c55aaa407a5';
var BUGSNAG_SERVER_API_KEY = 'e623f5118fda9d09c108f482f9dccfdf';
/**
 * The bugsnag client.
 * Allows for reporting handled errors.
 * See: https://docs.bugsnag.com/platforms/javascript/react/reporting-handled-errors/
 *
 * Before using, clients must configure using configureBugsnagClient.
 */

var bugsnagClient;
/**
 * Configures the bugsnag client.
 * This function must be called before attempting to use the bugsnagClient export.
 */

function configureBugsnagClient(_ref) {
  var _ref$appEnv = _ref.appEnv,
      appEnv = _ref$appEnv === void 0 ? '' : _ref$appEnv,
      _ref$appVersion = _ref.appVersion,
      appVersion = _ref$appVersion === void 0 ? 'APP_VERSION_UNDEFINED' : _ref$appVersion,
      _ref$beforeSend = _ref.beforeSend,
      beforeSend = _ref$beforeSend === void 0 ? function (report) {// Example: adding user id and email to bugsnag reports.
    // report.user = {
    //   id: userData.userId,
    //   email: userData.email
    // };
  } : _ref$beforeSend,
      _ref$isServer = _ref.isServer,
      isServer = _ref$isServer === void 0 ? false : _ref$isServer; // We will customize some behaviors for local dev.

  var ENV_LOCAL_DEV = 'local-dev'; // Determine the Release stage.
  // Useful for grouping bugs by environment.

  var releaseStage = ENV_LOCAL_DEV;

  if (process.env.NODE_ENV === 'production') {
    // first make sure we are using production compiled build
    switch (appEnv) {
      // then switch based on environment
      case 'dev':
        releaseStage = 'development';
        break;

      case 'staging':
        releaseStage = 'staging';
        break;

      case 'prod':
        releaseStage = 'production';
        break;
    }
  } // The bugsnag client with our configuration options.


  var config = {
    apiKey: isServer ? BUGSNAG_SERVER_API_KEY : BUGSNAG_CLIENT_API_KEY,
    appVersion: appVersion,
    beforeSend: beforeSend,
    releaseStage: releaseStage,
    // This instructs the bugsnag client to only send bug reports
    // when we are running in one of our production environments.
    // For local dev, we will instead console log out bugsnags.
    notifyReleaseStages: ['development', 'production', 'staging']
  };

  if (releaseStage === ENV_LOCAL_DEV) {
    config.autoBreadcrumbs = false; // do not hijack console logs for local dev
  } // Initialize the bugsnag client


  bugsnagClient = bugsnag(config);

  if (releaseStage === ENV_LOCAL_DEV) {
    // Local dev optimization.
    // Override the notify call and console log instead.
    bugsnagClient.notify = function (error, opts) {
      console.log(error);

      if (opts) {
        console.log(opts);
      }
    };
  } // Configure the bugsnag client with the React plugin.


  bugsnagClient.use(bugsnagReact, React);
}
/**
 * Some useful helpers for sending notifications with custom metaData.
 * @param {string|Error} message - Either an error message or Error instance.
 * @param {Object} metaData - Custom metaData to include with error report
 */


var bugsnagInfo = function bugsnagInfo(message, metaData) {
  _bugsnagCustomNotify(message, metaData, 'info');
};

var bugsnagWarn = function bugsnagWarn(message, metaData) {
  _bugsnagCustomNotify(message, metaData, 'warning');
};

var bugsnagError = function bugsnagError(message, metaData) {
  _bugsnagCustomNotify(message, metaData, 'error');
};

var _bugsnagCustomNotify = function _bugsnagCustomNotify(message, metaData, severity) {
  var error = typeof message === 'string' ? new Error(message) : message;
  bugsnagClient.notify(error, {
    severity: severity,
    metaData: metaData
  });
};

export { bugsnagClient, bugsnagError, bugsnagInfo, bugsnagWarn, configureBugsnagClient };